import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { lazyloadClass } from './styles';
import { addStack, removeStack } from '../utils/lazyload';
var DefaultProps = {
  offset: 0
};

var Lazyload =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Lazyload, _PureComponent);

  var _super = _createSuper2(Lazyload);

  function Lazyload(props) {
    var _this;

    _classCallCheck(this, Lazyload);

    _this = _super.call(this, props);
    _this.placeholder = void 0;
    _this.lazyId = void 0;

    _this.placeholderRef = function (el) {
      _this.placeholder = el;
    };

    _this.state = {
      ready: false
    };
    return _this;
  }

  _createClass(Lazyload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          container = _this$props.container,
          _this$props$offset = _this$props.offset,
          offset = _this$props$offset === void 0 ? DefaultProps.offset : _this$props$offset;
      this.lazyId = addStack({
        offset: offset,
        container: container,
        element: this.placeholder,
        render: function render() {
          return _this2.setState({
            ready: true
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeStack(this.lazyId);
    }
  }, {
    key: "render",
    value: function render() {
      var ready = this.state.ready;
      var _this$props2 = this.props,
          children = _this$props2.children,
          placeholder = _this$props2.placeholder;
      if (ready) return children;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          ref: this.placeholderRef,
          className: lazyloadClass('_')
        }, placeholder)
      );
    }
  }]);

  return Lazyload;
}(PureComponent);

Lazyload.defaultProps = DefaultProps;
export default Lazyload;